import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// context
import context from "../../store/context";

// hooks
import useInput from "../../hooks/use-Input";

// components
import Input from "../Input";
import RadioButtons from "./RadioButtons";
import CustomDropdown from "../Dropdown";
import AuthenticationButton from "../Buttons/AuthenticationButton";

//icons
import SearchIcon from "../icons/Search";
import LanguageIcon from "../icons/Language";
import TagIcon from "../icons/Tag";
import MapIcon from "../icons/Map";
import NewsPaperIcon from "../icons/NewsPaper";

const SearchSidebar = (props) => {
  const {
    categoryLists,
    regions,
    language,
    feedCategoryLists,
    feedRegions,
    feedLanguage,
    searchingTitle,
    setSearchingTitle,
    setSearchingCategoryId,
    setSearchingRegionId,
    setSearchingLanguageId,
    SearchTenders,
    selectedStatus,
    setSelectedStatus,
    tendersCategoryLists,
    tendersRegions,
    tendersLanguage,
    tendersSrc,
    setSearchingSrc,
  } = useContext(context);

  const { enteredValue, valueChangeHandler } = useInput(
    () => true,
    searchingTitle || ""
  );

  useEffect(() => {
    setSearchingTitle(() => enteredValue);
  }, [enteredValue, setSearchingTitle]);

  const handleOptionSelect = (option, dropdownId) => {
    if (dropdownId === 1) {
      setSearchingLanguageId(option);
    } else if (dropdownId === 2) {
      setSearchingRegionId(option);
    } else if (dropdownId === 3) {
      if (option !== null) {
        setSearchingCategoryId(option);
      }
    } else if (dropdownId === 4) {
      setSearchingSrc(option);
    }
  };

  const handleOptionChange = (event) => {
    setSelectedStatus(event.target.id);
  };

  const navigate = useNavigate();

  const searchSubmitHandler = (event) => {
    event.preventDefault();

    SearchTenders();
    if (props.redirect) {
      navigate(props.redirectTo || "/tenders");
    }
  };
  const languageOptions =
    props.filter === ""
      ? tendersLanguage
      : props.filter === "myfeed"
      ? feedLanguage
      : language;
  const regionOptions =
    props.filter === ""
      ? tendersRegions
      : props.filter === "myfeed"
      ? feedRegions
      : regions;
  const categoryOptions =
    props.filter === ""
      ? tendersCategoryLists
      : props.filter === "myfeed"
      ? feedCategoryLists
      : categoryLists;

  const fieldLabel = (Icon, name) => (
    <div className="flex items-center mb-1.5">
      <Icon styles="w-3.5 h-3.5 mr-1.5" />
      <h1 className="font-medium text-xs text-gray-500">{name}</h1>
    </div>
  );

  if (props.compact) {
    return (
      <form className="w-full flex flex-col gap-3" onSubmit={searchSubmitHandler}>
        <Input
          onChange={valueChangeHandler}
          rounded="rounded-full"
          type="text"
          id="searchText"
          lable="Title"
        >
          <SearchIcon styles="w-6 h-6 mx-3 text-slate-400" />
        </Input>

        <div className="grid grid-cols-2 gap-3 text-gray-500">
          <div>
            {fieldLabel(LanguageIcon, "Language")}
            <CustomDropdown
              options={languageOptions}
              defaultValue={"All"}
              onSelect={handleOptionSelect}
              dropdownId={1}
            />
          </div>
          <div>
            {fieldLabel(MapIcon, "Region")}
            <CustomDropdown
              options={regionOptions}
              defaultValue={"All"}
              onSelect={handleOptionSelect}
              dropdownId={2}
            />
          </div>
          <div>
            {fieldLabel(TagIcon, "Category")}
            <CustomDropdown
              options={categoryOptions}
              defaultValue={"All"}
              onSelect={handleOptionSelect}
              dropdownId={3}
            />
          </div>
          <div>
            {fieldLabel(NewsPaperIcon, "Published")}
            <CustomDropdown
              options={tendersSrc}
              defaultValue={"All"}
              onSelect={handleOptionSelect}
              dropdownId={4}
            />
          </div>
        </div>

        <div className="grid grid-cols-3 gap-2">
          <RadioButtons
            id=""
            onChange={handleOptionChange}
            name="All"
            active={selectedStatus}
            compact
            styles="border border-[#664bc7]/30"
          />
          <RadioButtons
            id="1"
            onChange={handleOptionChange}
            name="Open"
            active={selectedStatus}
            compact
            styles="border border-green-400/30"
          />
          <RadioButtons
            id="0"
            onChange={handleOptionChange}
            name="Closed"
            active={selectedStatus}
            compact
            styles="border border-red-400/30"
          />
        </div>

        <AuthenticationButton onClick={searchSubmitHandler} name="Search" />
      </form>
    );
  }

  return (
    <form type="submit" className="w-full flex flex-col">
      <div className="w-full md:h-[60px] mb-5 hidden md:flex items-center justify-center bg-[#664bc7]/5 text-[#664bc7]/70 text-lg rounded-b-md font-semibold">
        <h1>
          Search{" "}
          {props.filter === "myfeed"
            ? "My Feed"
            : props.filter === "saved"
            ? "Saved"
            : "Tenders"}
        </h1>
      </div>
      <Input
        onChange={valueChangeHandler}
        rounded="rounded-full"
        type="text"
        id="searchText"
        lable="Title"
      >
        <SearchIcon styles="w-6 h-6 mx-3 text-slate-400" />
      </Input>

      <div className="flex flex-col w-full space-y-7 text-gray-500">
        <div className="flex flex-col space-y-3">
          <div className="flex items-center">
            <LanguageIcon styles="w-4 h-4 mr-2" />
            <h1 className="font-medium text-sm  text-gray-500">Language</h1>
          </div>
          <CustomDropdown
            options={languageOptions}
            defaultValue={"All"}
            onSelect={handleOptionSelect}
            dropdownId={1}
          />
        </div>
        <div className="flex flex-col space-y-3">
          <div className="flex items-center">
            <MapIcon styles="w-4 h-4 mr-2" />
            <h1 className="font-medium  text-sm text-gray-500">Regions</h1>
          </div>
          <CustomDropdown
            options={regionOptions}
            defaultValue={"All"}
            onSelect={handleOptionSelect}
            dropdownId={2}
          />
        </div>
        <div className="flex flex-col space-y-3">
          <div className="flex items-center">
            <TagIcon styles="w-4 h-4 mr-2" />
            <h1 className="font-medium text-sm  text-gray-500">Category</h1>
          </div>
          <CustomDropdown
            options={categoryOptions}
            defaultValue={"All"}
            onSelect={handleOptionSelect}
            dropdownId={3}
          />
        </div>
        <div className="flex flex-col space-y-3">
          <div className="flex items-center">
            <NewsPaperIcon styles="w-4 h-4 mr-2" />
            <h1 className="font-medium text-sm  text-gray-500">Published On</h1>
          </div>
          <CustomDropdown
            options={tendersSrc}
            defaultValue={"All"}
            onSelect={handleOptionSelect}
            dropdownId={4}
          />
        </div>
      </div>
      <div className="py-7 grid grid-cols-3 gap-6">
        <RadioButtons
          id=""
          onChange={handleOptionChange}
          name="All"
          active={selectedStatus}
          styles="border border-[#664bc7]/30"
        />
        <RadioButtons
          id="1"
          onChange={handleOptionChange}
          name="Open"
          active={selectedStatus}
          styles="border border-green-400/30"
        />
        <RadioButtons
          id="0"
          onChange={handleOptionChange}
          name="Closed"
          active={selectedStatus}
          styles="border border-red-400/30"
        />
      </div>
      <AuthenticationButton onClick={searchSubmitHandler} name="Search" />

      <div className="flex space-x-4"></div>
    </form>
  );
};

export default SearchSidebar;
